import React from 'react';
import { LockKeyholeIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
export function Header() {
  return <header className="border-b border-gold-700 bg-[#b8860b] px-4 py-2 text-center text-xs font-semibold text-black" data-id="element-70">
      <div className="mx-auto flex max-w-6xl flex-wrap items-center justify-center gap-x-5 gap-y-1.5" data-id="element-71">
        <span className="inline-flex items-center gap-1" data-id="element-72">
          <ShieldCheckIcon size={14} data-id="element-73" /> 7-day guarantee
        </span>
        <span className="hidden sm:inline" data-id="element-74">•</span>
        <span className="inline-flex items-center gap-1" data-id="element-75">
          <LockKeyholeIcon size={14} data-id="element-76" /> Secure payment
        </span>
        <span className="hidden sm:inline" data-id="element-77">•</span>
        <span className="inline-flex items-center gap-1" data-id="element-78">
          <ZapIcon size={14} data-id="element-79" /> Immediate access
        </span>
        <span className="hidden sm:inline" data-id="element-80">•</span>
        <span data-id="element-81">Pay in your local currency</span>
      </div>
    </header>;
}